import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  InputLabel,
  RadioProps
} from '@mui/material';
import { t } from 'i18next';
import { ReactNode } from 'react';
import { ControllerRenderProps, FieldValues, useController } from 'react-hook-form';
import { OptionField } from 'types/form.type';

interface Props extends Omit<RadioProps, 'label'> {
  label: string | ReactNode;
  options: OptionField[];
  hookForm?: ControllerRenderProps<FieldValues, string>;
  fullWidth?: boolean;
}

const RadioInput = ({ name, label, hookForm, options, ...props }: Props) => {
  const { fieldState } = useController({ name: hookForm?.name ?? '' });

  return (
    <FormControl sx={{ pt: 2, mb: 2 }} fullWidth={props.fullWidth} error={Boolean(fieldState.error?.message)}>
      <InputLabel shrink htmlFor={name} error={Boolean(fieldState.error?.message)}>
        {label}
      </InputLabel>
      <RadioGroup row name={`${label}-buttons-group`} {...hookForm}>
        {options.map((option) => (
          <FormControlLabel key={option.label} value={option.value} control={<Radio />} label={t(option.label)} />
        ))}
      </RadioGroup>
      <FormHelperText sx={{ m: 0 }}>{fieldState.error?.message}</FormHelperText>
    </FormControl>
  );
};

export default RadioInput;
